module.exports = __webpack_public_path__ + "img/stamp.91ad745c.svg";